import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-more-info-trigger.css';
import { a as analyticsTracker } from '../analytics-tracker/index-chunk.esm.js';

const EGDSMoreInfoTriggerSizesArray = ['small', 'medium', 'large'];
const EGDSMoreInfoTriggerWeightsArray = ['regular', 'bold'];
const EGDSMoreInfoTriggerAlignsArray = ['leading', 'center', 'trailing'];
const EGDSMoreInfoTriggerThemesArray = ['default', 'emphasis', 'positive', 'negative', 'inverse'];

const getClassNameList = classNames.bind(styles);
class EGDSMoreInfoTrigger extends React.PureComponent {
    static displayName = 'EGDSMoreInfoTrigger';
    static defaultProps = {
        size: EGDSMoreInfoTriggerSizesArray[EGDSMoreInfoTriggerSizesArray.indexOf('medium')],
        weight: EGDSMoreInfoTriggerWeightsArray[EGDSMoreInfoTriggerWeightsArray.indexOf('regular')],
        theme: EGDSMoreInfoTriggerThemesArray[EGDSMoreInfoTriggerThemesArray.indexOf('default')],
        align: EGDSMoreInfoTriggerAlignsArray[EGDSMoreInfoTriggerAlignsArray.indexOf('leading')],
    };
    render() {
        const { children, size, weight, domRef, theme, align, className, analytics, ...props } = this.props;
        const childrenArray = React.Children.toArray(children);
        let firstChild = childrenArray[0];
        const baseCssClass = 'uitk-more-info-trigger';
        const childClassName = getClassNameList(baseCssClass, `${baseCssClass}-size-${size}`, `${baseCssClass}-weight-${weight}`, `${baseCssClass}-theme-${theme}`, `${baseCssClass}-align-${align}`, className);
        if (!props.onClickCapture && analytics) {
            props.onClickCapture = analyticsTracker.bind(this, analytics);
        }
        firstChild = React.cloneElement(firstChild, firstChild.props, React.Children.map(firstChild.props.children, (child) => {
            if (!child) {
                return;
            }
            if (React.isValidElement(child) && child.type.displayName?.match(/(EGDS|Uitk)Icon/)) {
                return (jsx("div", { className: getClassNameList(`${baseCssClass}-icon-container`, `${baseCssClass}-size-${size}-icon-container`), ref: domRef, children: React.cloneElement(child, {
                        size: 'small',
                        className: getClassNameList(`${baseCssClass}-icon`, `${baseCssClass}-icon-theme-${theme}`),
                    }) }));
            }
            return child;
        }));
        const decoratedChild = React.cloneElement(firstChild, {
            analytics,
            className: childClassName,
            ...props,
        });
        return decoratedChild;
    }
}

export { EGDSMoreInfoTrigger as E };
//# sourceMappingURL=index-chunk.esm.js.map
